/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
 const searchForm = document.querySelector(".search-bar");
  if(searchForm){
    searchForm.addEventListener("click", function (e) {
    	if(e.target.closest(".search-bar__input")){
          !searchForm.classList.contains("is-expanded") ? searchForm.classList.add("is-expanded") : null;
        }
        if(e.target.closest(".new-results__items li")){
          const searchText = e.target.closest(".new-results__items li").innerText.toLowerCase();
          window.location.assign('/search?q=' + searchText);
        }
    });
  }
const getCart = () => {
	return fetch(window.Shopify.routes.root + "cart.js").then((response) => response.json());
};

function addItemToCart(id, qty, cback) {
	let formData = {
		items: [
			{
				id: id,
				quantity: qty,
			},
		],
	};
	fetch("/cart/add.js", {
		method: "POST",
		credentials: "same-origin",
		headers: {
			"Content-Type": "application/json",
			"X-Requested-With": "XMLHttpRequest",
		},
		body: JSON.stringify(formData),
	})
		.then((response) => {
			cback();
			return response.json();
		})
		.catch((error) => {
			console.error("Error:", error);
		});
}

function updateItemInCart(id, qty, cback) {
	let formData = {
		updates: {
			[id]: qty,
		},
	};
	fetch("/cart/update.js", {
		method: "POST",
		credentials: "same-origin",
		headers: {
			"Content-Type": "application/json",
			"X-Requested-With": "XMLHttpRequest",
		},
		body: JSON.stringify(formData),
	})
		.then((response) => {
			cback();
			return response.json();
		})
		.catch((error) => {
			console.error("Error:", error);
		});
}

document.addEventListener("DOMContentLoaded", function () {
	function handleUpsellPrices(priceWrapEl, upsellItems) {
		let rawPrice = Number(priceWrapEl.dataset.rawPrice);
		let priceEl = priceWrapEl.querySelector(".price");
		let priceCompareEl = priceWrapEl.querySelector(".price.price--compare");
		let newPrice = rawPrice;

		if (upsellItems) {
			upsellItems.forEach(function (el) {
				let price = Number(el.dataset.price);
				if (el.checked) {
					newPrice = newPrice + price;
				}
			});
			priceEl.innerHTML = (newPrice / 100).toFixed(2).toString().replace(".", ",");

			if (priceCompareEl) {
				let rawComparePrice = Number(priceWrapEl.dataset.rawComparePrice);
				let newComparePrice = rawComparePrice;
				upsellItems.forEach(function (el) {
					let priceC = Number(el.dataset.comparePrice);
					if (el.checked) {
						newComparePrice = newComparePrice + priceC;
					}
				});
				priceCompareEl.innerHTML = (newComparePrice / 100).toFixed(2).toString().replace(".", ",");
			}
		}
	}

	if (document.body.classList.contains("template-product")) {
		var upsellSection = document.querySelectorAll('[name="upsell-product"]');
		var prodUpsellForm = document.querySelectorAll(".prodUpsellForm");
		var atcAddDynamicEl = document.querySelectorAll(".atcAddDynamicEl");

		function extractData(elems) {
			let price = 0;
			let items = [];
			elems.forEach(function (el) {
				var prc = Number(el.dataset.price);
				var id = Number(el.dataset.relId);
				if (el.checked) {
					let item = {
						id: id,
						quantity: 1,
					};
					price += prc;
					items.push(item);
				}
			});
			let obj = {
				price: price,
				items: items,
			};
			return obj;
		}

		upsellSection.forEach(function (el) {
			var $this = el;
			var id = $this.dataset.relId;
			var parent = $this.closest(".prodUpsell");
			var totPrcEl = parent.querySelector(".prodUpsellTotal");
			var relatedThumb = parent.querySelector('.prodUpsellCell[data-id="' + id + '"]');
			$this.addEventListener("change", function () {
				let totPrice = extractData(upsellSection).price / 100;
				if ($this.checked) {
					relatedThumb.classList.remove("d-none");
				} else {
					relatedThumb.classList.add("d-none");
				}
				totPrcEl.innerHTML = totPrice.toString().replace(".", ",");
			});
		});

		prodUpsellForm.forEach(function (el) {
			el.addEventListener("submit", function (e) {
				var redirect = el.dataset.redirect;
				var checkboxes = el.querySelectorAll('[name="upsell-product"]');
				var items = extractData(checkboxes).items;
				if (items && items.length) {
					e.preventDefault();
					let formData = {
						items: items,
					};
					fetch("/cart/add.js", {
						method: "post",
						headers: {
							"Content-Type": "application/json",
						},
						body: JSON.stringify(formData),
					})
						.then((response) => {
							console.log(response.json());
							window.location.href = redirect;
						})
						.catch((error) => {
							console.error("Error:", error);
						});
				}
			});
		});

		var upsellCheckbox = document.querySelectorAll(".upsellCheckbox");
		if (upsellCheckbox) {
			upsellCheckbox.forEach(function (el) {
				let priceWrapper = el.closest(".productSidebar").querySelector(".priceWrapper");
				let wrapper = el.closest(".upsellCheckboxesWrapper");
				let parent = el.closest(".upsellCheckboxes");
				let itemAndSiblings = parent.querySelectorAll(".upsellCheckbox");
				let parentsSiblings = wrapper ? wrapper.querySelectorAll(".upsellCheckboxes") : false;
				el.addEventListener("change", () => {
					var varID = el.dataset.relId;
					if (parentsSiblings.length > 1) {
						let syncedItems = wrapper.querySelectorAll('.upsellCheckboxes.d-none .upsellCheckbox[data-rel-id="' + varID + '"]');
						if (syncedItems) {
							syncedItems.forEach(function (item) {
								item.checked = el.checked;
							});
						}
					}

					handleUpsellPrices(priceWrapper, itemAndSiblings);
				});
			});
		}

		var productForm = document.querySelectorAll(".productForm");
		if (productForm) {
			productForm.forEach(function (el) {
				let submitBtn = el.querySelector(".productATC");
				submitBtn &&
					submitBtn.addEventListener("click", (e) => {
						let currentVariantID = window.SELECTED_VARIANT_ID;
						let upsellCheckbox = el.querySelectorAll('.upsellCheckbox[data-sel-id="' + currentVariantID + '"]:checked');
						var items = extractData(upsellCheckbox).items;
						let formData = {
							items: items,
						};
						if (upsellCheckbox) {
							if (items && items.length) {
								e.preventDefault();
								fetch("/cart/add.js", {
									method: "post",
									headers: {
										"Content-Type": "application/json",
									},
									body: JSON.stringify(formData),
								})
									.then((response) => {
										console.log(response);
										el.submit();
									})
									.catch((error) => {
										console.error("Error:", error);
									});
							}
						}
					});
			});
		}

		document.addEventListener("variant:changed", function (event) {
			var variant = event.detail.variant;
			var priceWrapper = document.querySelector(".priceWrapper");

			var variantDeliveryItems = document.querySelectorAll(".variantDelivery");
			var variantDeliveryItem = document.querySelectorAll('.variantDelivery[data-variant-id="' + variant.id + '"]');

			var upsellCheckboxes = document.querySelectorAll(".upsellCheckboxes");
			var activeUpsellCheckbox = document.querySelector('.upsellCheckboxes[data-id="' + variant.id + '"]');

			// Price change
			if (priceWrapper) {
				priceWrapper.dataset.rawPrice = variant.price;
				window.SELECTED_VARIANT_ID = variant.id;
			}

			// Delivery time messages
			if (variantDeliveryItems) {
				variantDeliveryItems.forEach(function (el) {
					el.classList.add("d-none");
				});
			}
			if (variantDeliveryItem) {
				variantDeliveryItem.forEach(function (el) {
					el.classList.remove("d-none");
				});
			}

			// Upsell checkboxes
			if (upsellCheckboxes) {
				upsellCheckboxes.forEach(function (el) {
					el.classList.add("d-none");
					el.classList.add("is-active");
				});
			}
			if (activeUpsellCheckbox) {
				activeUpsellCheckbox.classList.remove("d-none");
				activeUpsellCheckbox.classList.remove("is-active");
			}
			handleUpsellPrices(priceWrapper, activeUpsellCheckbox.querySelectorAll(".upsellCheckbox"));
		});

		atcAddDynamicEl.forEach(function (el) {
			let btnAdd = el.querySelector(".atcDynamicBtnAdd");
			let btnRmv = el.querySelector(".atcAddDynamicBtnRmv");

			function onCartChanged() {
				getCart().then((data) => {
					let cartItemsCount = document.querySelectorAll(".header__cart-count");
					cartItemsCount &&
						cartItemsCount.forEach((cntr) => {
							cntr.innerHTML = data.item_count;
						});
				});
			}

			function onAddedToCart() {
				el.classList.add("added");
				onCartChanged();
			}

			function onRemovedFromCart() {
				el.classList.remove("added");
				onCartChanged();
			}

			btnAdd.addEventListener("click", function (e) {
				let varId = btnAdd.dataset.variantId;
				let varQty = btnAdd.dataset.quantity;

				addItemToCart(varId, varQty, onAddedToCart);
			});

			btnRmv.addEventListener("click", function (e) {
				let varId = btnAdd.dataset.variantId;

				updateItemInCart(varId, 0, onRemovedFromCart);
			});
		});
	}
});

var hideBlockIfEmpty = document.querySelectorAll(".hideBlockIfEmpty");
if (hideBlockIfEmpty) {
	hideBlockIfEmpty.forEach(function (el) {
		let content = el.querySelector(".hideBlockIfEmptyContent");
		if (content.innerHTML.trim() === "") {
			el.classList.add("d-none");
		}
	});
}

var reviewScore = document.querySelectorAll(".reviewScore");
if (reviewScore && typeof REVIEW_SCORE !== "undefined") {
	reviewScore.forEach(function (el) {
		el.innerHTML = REVIEW_SCORE;
	});
}

var langSwitch = document.querySelectorAll("[data-switch-lang]");
if (langSwitch) {
	langSwitch.forEach((el) => {
		el.addEventListener("click", function () {
			fetch("https://spreadsheets.google.com/feeds/list/1VDNMeN2sFEuKcDaNuvn0Xt8FTsdCr7vqW3bd0AXor_E/od6/public/values?alt=json", {
				method: "GET",
			}).then((response) => {
				console.log(response.status, response.text);
			});
		});
	});
}
const atcBottomEdge = document.querySelectorAll(".atcBottomEdge");
function handleDocumentScrolledClass() {
    (window.pageYOffset || (document.documentElement || document.body.parentNode || document.body).scrollTop) > 0 ? document.documentElement.classList.add("is-scrolled") : document.documentElement.classList.remove("is-scrolled");
}
function isElemScrolledOutOfView(e) {
    e.forEach((e) => {
        let t = e.getBoundingClientRect(),
            i = document.querySelector(".product-form__payment-container"),
            r = document.body.scrollTop,
            s = t.top + r,         
            l = document.querySelector(".shopify-section__header#shopify-section-header").offsetHeight,
            topValue = s - window.innerHeight - i.offsetHeight;
            
        // (r > s || topValue>0) ? (document.body.classList.add("is-atc-sticky"), window.innerWidth > 1e3 && (i.style.top = `${l}px`)) : (document.body.classList.remove("is-atc-sticky"), window.innerWidth > 1e3 && (i.style.top = 0));
        (r > s) ? (document.body.classList.add("is-atc-sticky"), window.innerWidth > 1e3 && (i.style.top = `${l}px`)) : (document.body.classList.remove("is-atc-sticky"), window.innerWidth > 1e3 && (i.style.top = 0));
    });
}
function announcementBarHeight (){
  const target = document.querySelector("#shopify-section-announcement-bar") || document.querySelector("#shopify-section-new-announcement-bar");
  
   if(target){
     let options = {
        root: null,
        rootMargin: '0px',
        threshold: 1
    }
      const intersectionCallback = (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
             // a = target.offsetHeight;
              // const top = document.querySelector(".product-form__payment-container").style.top.split("px")[0];
              const header = document.querySelector("#shopify-section-header").offsetHeight
              const newTop = header + target.offsetHeight;
              document.querySelector(".product-form__payment-container") ? document.querySelector(".product-form__payment-container").style.top = `${newTop}px` : null;
            }
            // } else{
            //   // document.querySelector(".product-form__payment-container").style.marginTop = `0px`
  
            // }
  
          });
        };
      const observer = new IntersectionObserver(intersectionCallback, options);
      observer.observe(target);
   }
}

atcBottomEdge &&
    (isElemScrolledOutOfView(atcBottomEdge), announcementBarHeight(),
    window.addEventListener("scroll", () => {
        isElemScrolledOutOfView(atcBottomEdge);
      announcementBarHeight();
    })),
    handleDocumentScrolledClass(),
    window.addEventListener("scroll", () => {
        handleDocumentScrolledClass();
    });
   

// const atcBottomEdge = document.querySelectorAll(".atcBottomEdge");
// function handleDocumentScrolledClass() {
//     (window.pageYOffset || (document.documentElement || document.body.parentNode || document.body).scrollTop) > 0 ? document.documentElement.classList.add("is-scrolled") : document.documentElement.classList.remove("is-scrolled");
// }
// function isElemScrolledOutOfView(e) {
//     e.forEach((e) => {
//         let t = e.getBoundingClientRect(),
//             r = document.body.scrollTop,
//             s = t.top + r,         
//             i = document.querySelector(".product-form__payment-container"),
//              l = document.querySelector("#shopify-section-header").offsetHeight,
//             top = s - window.innerHeight - i.offsetHeight;
//         (r > s || top>0) ? (document.body.classList.add("is-atc-sticky"), window.innerWidth > 1e3 && (i.style.top = `${l}px`)) : (document.body.classList.remove("is-atc-sticky"), window.innerWidth > 1e3 && (i.style.top = 0));
           
//     });
// }
// function announcementBarHeight (){
//   const target = document.querySelector(".announcement-bar");
  
//    if(target){
//      let options = {
//         root: null,
//         rootMargin: '0px',
//         threshold: 1
//     }
//       const intersectionCallback = (entries) => {
//           entries.forEach((entry) => {
//             if (entry.isIntersecting) {
//               const header = document.querySelector("#shopify-section-header").offsetHeight
//               const newTop = header + target.offsetHeight;
//               document.querySelector(".product-form__payment-container") ? document.querySelector(".product-form__payment-container").style.top = `${newTop}px` : null;
//             }
//             // } else{
  
//             // }
  
//           });
//         };
//       const observer = new IntersectionObserver(intersectionCallback, options);
//       observer.observe(target);
//    }
// }

// atcBottomEdge &&
//     (isElemScrolledOutOfView(atcBottomEdge), announcementBarHeight(),
//     window.addEventListener("scroll", () => {
//         isElemScrolledOutOfView(atcBottomEdge);
//       announcementBarHeight();
//     })),
//     handleDocumentScrolledClass(),
//     window.addEventListener("scroll", () => {
//         handleDocumentScrolledClass();
//     });;

let sliderTag = null;
let sliderProduct = null;
let sliderIcons = null;
let sliderOffers = null;
// let sliderBlogPosts = null;
let mediaQuerySizeLarge = 1000;
let mediaQuerySize = 640;
function sliderTagInit() {
	if (document.querySelector(".swiper.tag-swiper")) {
		if (!sliderTag) {
			sliderTag = new Swiper(".swiper.tag-swiper", {
				// observer: true,
				// observeParents: true,
				slidesPerView: "auto",
				spaceBetween: 11,
				// navigation: {
				// 	prevEl: ".catalog__arrows .arrows-slider__prev",
				// 	nextEl: ".catalog__arrows .arrows-slider__next",
				// },
				// breakpoints: {
				// 	319: {
				// 		slidesPerView: "auto",
				// 		// spaceBetween: -32,
				// 		autoHeight: true,
				// 	},
				// },
				scrollbar: {
					el: ".swiper.tag-swiper .swiper-scrollbar",
					draggable: true,
					snapOnRelease: true,
				},
				on: {},
			});
		}
	}
}
function sliderTagDestroy() {
	if (sliderTag) {
		console.log(sliderTag);
		sliderTag.destroy();
		sliderTag = null;
	}
}
function sliderProductInit() {
	if (document.querySelector(".blog-sidebar-swiper")) {
		if (!sliderProduct) {
			sliderProduct = new Swiper(".blog-sidebar-swiper", {
				// observer: true,
				// observeParents: true,
				slidesPerView: 1,
				spaceBetween: 20,
				// navigation: {
				// 	prevEl: ".catalog__arrows .arrows-slider__prev",
				// 	nextEl: ".catalog__arrows .arrows-slider__next",
				// },
				// breakpoints: {
				// 	319: {
				// 		slidesPerView: "auto",
				// 		// spaceBetween: -32,
				// 		autoHeight: true,
				// 	},
				// },
				scrollbar: {
					el: ".blog-sidebar-swiper .swiper-scrollbar",
					draggable: true,
				},
				on: {},
			});
		}
	}
}
function sliderProductDestroy() {
	if (sliderProduct) {
		sliderProduct.destroy();
		sliderProduct = null;
	}
}
function sliderIconsInit() {
	if (document.querySelector(".swiper-text-icons")) {
		if (!sliderIcons) {
			sliderIcons = new Swiper(".swiper-text-icons", {
				// observer: true,
				// observeParents: true,
				slidesPerView: 1,
				spaceBetween: 20,
				// navigation: {
				// 	prevEl: ".catalog__arrows .arrows-slider__prev",
				// 	nextEl: ".catalog__arrows .arrows-slider__next",
				// },
				// breakpoints: {
				// 	319: {
				// 		slidesPerView: "auto",
				// 		// spaceBetween: -32,
				// 		autoHeight: true,
				// 	},
				// },
				scrollbar: {
					el: ".swiper-text-icons .swiper-scrollbar",
					draggable: true,
				},
				on: {},
			});
		}
	}
}
function sliderIconsDestroy() {
	if (sliderIcons) {
		sliderIcons.destroy();
		sliderIcons = null;
	}
}
function sliderOffersDestroy() {
	if (sliderOffers) {
		sliderOffers.destroy();
		sliderOffers = null;
	}
}
function sliderOffersInit() {
	if (document.querySelector(".swiper.swiper-offers")) {
		if (!sliderOffers) {
			sliderOffers = new Swiper(".swiper.swiper-offers", {
				// observer: true,
				// observeParents: true,
				slidesPerView: "auto",
				spaceBetween: 32,
				scrollbar: {
					el: ".swiper.swiper-offers .swiper-scrollbar",
					draggable: true,
					snapOnRelease: true,
				},
			});
		}
	}
}
// function sliderBlogPostsInit() {
// 	if (document.querySelector(".swiper-blogs-list")) {
// 		if (!sliderBlogPosts) {
// 			// Вказуємо склас потрібного слайдера
// 			// Створюємо слайдер
// 			sliderBlogPosts = new Swiper(".swiper-blogs-list", {
// 				// Вказуємо склас потрібного слайдера
// 				// Підключаємо модулі слайдера
// 				// для конкретного випадку
// 				observer: true,
// 				observeParents: true,
// 				slidesPerView: 3,
// 				spaceBetween: 16,
// 				speed: 800,
// 				// Скроллбар

// 				scrollbar: {
// 					el: ".swiper-blogs-list .swiper-scrollbar",
// 					draggable: true,
// 				},

// 				// Кнопки "вліво/вправо"
// 				navigation: {
// 					prevEl: ".swiper-blogs-list .swiper-button-prev",
// 					nextEl: ".swiper-blogs-list  .swiper-button-next",
// 				},

// 				// Брейкпоінти
// 				breakpoints: {
// 					320: {
// 						slidesPerView: 1.2,
// 						spaceBetween: 15,
// 					},
// 					640: {
// 						slidesPerView: 2.2,
// 						spaceBetween: 15,
// 					},
// 					991: {
// 						slidesPerView: 2.5,
// 						spaceBetween: 26,
// 					},
// 				},

// 				// Події
// 				on: {},
// 			});
// 		}
// 	}
// }
// function sliderBlogPostsDestroy() {
// 	if (sliderBlogPosts) {
// 		sliderBlogPosts.destroy();
// 		sliderBlogPosts = null;
// 	}
// }
function initSliders() {
	// Список слайдерів
	// Перевіряємо, чи є слайдер на сторінці
	if (document.querySelector(".swiper-upsells")) {
		// Вказуємо склас потрібного слайдера
		// Створюємо слайдер
		new Swiper(".swiper-upsells", {
			// Вказуємо склас потрібного слайдера
			// Підключаємо модулі слайдера
			// для конкретного випадку
			observer: true,
			observeParents: true,
			slidesPerView: 3,
			spaceBetween: 16,
			// autoHeight: true,
			// centeredSlides: true,
			// centerInsufficientSlides: true,
			speed: 800,

			//touchRatio: 0,
			//simulateTouch: false,
			//loop: true,
			//preloadImages: false,
			//lazy: true,

			/*
			 // Ефекти
			 effect: 'fade',
			 autoplay: {
				 delay: 3000,
				 disableOnInteraction: false,
			 },
			 */

			// Пагінація
			/*
			 pagination: {
				 el: '.swiper-pagination',
				 clickable: true,
			 },
			 */

			// Скроллбар
			/*
			 scrollbar: {
				 el: '.swiper-scrollbar',
				 draggable: true,
			 },
			 */

			// Кнопки "вліво/вправо"
			navigation: {
				prevEl: ".pdp-upsells__swiper-buttons .swiper-button-prev",
				nextEl: ".pdp-upsells__swiper-buttons .swiper-button-next",
			},

			// Брейкпоінти
			breakpoints: {
				320: {
					slidesPerView: 1.15,
					spaceBetween: 10,
				},
				467: {
					slidesPerView: 1.8,
					spaceBetween: 16,
				},
				640: {
					slidesPerView: 3,
					spaceBetween: 16,
				},
			},

			// Події
			on: {},
		});
	}
	if (document.querySelector(".swiper-products-list")) {
		// Вказуємо склас потрібного слайдера
		// Створюємо слайдер
		new Swiper(".swiper-products-list", {
			// Вказуємо склас потрібного слайдера
			// Підключаємо модулі слайдера
			// для конкретного випадку
			observer: true,
			observeParents: true,
			slidesPerView: 3,
			spaceBetween: 16,
			speed: 800,

			// Пагінація
			/*
			 pagination: {
				 el: '.swiper-pagination',
				 clickable: true,
			 },
			 */

			// Скроллбар

			scrollbar: {
				el: ".swiper-products-list .swiper-scrollbar",
				draggable: true,
			},

			// Кнопки "вліво/вправо"
			navigation: {
				prevEl: ".swiper-products-list .swiper-button-prev",
				nextEl: ".swiper-products-list  .swiper-button-next",
			},

			// Брейкпоінти
			breakpoints: {
				320: {
					slidesPerView: 1.15,
					spaceBetween: 10,
				},
				467: {
					slidesPerView: 1.8,
					spaceBetween: 16,
				},
				640: {
					slidesPerView: 2.8,
					spaceBetween: 17.5,
				},
				991: {
					slidesPerView: 3.3,
					spaceBetween: 17.5,
				},
				1200: {
					slidesPerView: 5,
					spaceBetween: 17.5,
				},
			},

			// Події
			on: {},
		});
	}
	if (document.querySelector(".cart-wrapper .swiper-products-list")) {
		// Вказуємо склас потрібного слайдера
		// Створюємо слайдер
		new Swiper(".cart-wrapper .swiper-products-list", {
			// Вказуємо склас потрібного слайдера
			// Підключаємо модулі слайдера
			// для конкретного випадку
			observer: true,
			observeParents: true,
			slidesPerView: 3,
			spaceBetween: 16,
			speed: 800,

			// Пагінація
			/*
			 pagination: {
				 el: '.swiper-pagination',
				 clickable: true,
			 },
			 */

			// Скроллбар

			// scrollbar: {
			// 	el: ".cart-wrapper .swiper-products-list .cart-scrollbar.swiper-scrollbar",
			// 	draggable: false,
			// },

			// Кнопки "вліво/вправо"
			navigation: {
				prevEl: ".swiper-products-list .swiper-button-prev",
				nextEl: ".swiper-products-list  .swiper-button-next",
			},

			// Брейкпоінти
			breakpoints: {
				320: {
					slidesPerView: 1.15,
					spaceBetween: 10,
				},
				467: {
					slidesPerView: 1.8,
					spaceBetween: 16,
				},
				640: {
					slidesPerView: 2.8,
					spaceBetween: 17.5,
				},
				999: {
					slidesPerView: 2.2,
					spaceBetween: 17.5,
				},
				1200: {
					slidesPerView: 4,
					spaceBetween: 17.5,
				},
			},

			// Події
			on: {},
		});
	}
    if (document.querySelector(".section__blog-post .swiper-products-list")) {
		// Вказуємо склас потрібного слайдера
		// Створюємо слайдер
		new Swiper(".section__blog-post .swiper-products-list", {
			// Вказуємо склас потрібного слайдера
			// Підключаємо модулі слайдера
			// для конкретного випадку
			observer: true,
			observeParents: true,
			slidesPerView: 3,
			spaceBetween: 16,
			speed: 800,

			// Пагінація
			/*
			 pagination: {
				 el: '.swiper-pagination',
				 clickable: true,
			 },
			 */

			// // Скроллбар

			// scrollbar: {
			// 	el: ".section__blog-post .swiper-products-list .swiper-scrollbar",
			// 	draggable: true,
			// },

			// Кнопки "вліво/вправо"
			navigation: {
				prevEl: ".section__blog-post .swiper-products-list .swiper-button-prev",
				nextEl: ".section__blog-post .swiper-products-list  .swiper-button-next",
			},

			// Брейкпоінти
			breakpoints: {
				320: {
					slidesPerView: 1.15,
					spaceBetween: 10,
				},
				467: {
					slidesPerView: 1.8,
					spaceBetween: 16,
				},
				640: {
					slidesPerView: 2.8,
					spaceBetween: 17.5,
				},
				991: {
					slidesPerView: 2.8,
					spaceBetween: 17.5,
				}
			},

			// Події
			on: {},
		});
	}
   if (document.querySelector(".image-with-text__slider-target.swiper")) {
		// Вказуємо склас потрібного слайдера
		// Створюємо слайдер
		new Swiper(".image-with-text__slider-target.swiper", {
			// Вказуємо склас потрібного слайдера
			// Підключаємо модулі слайдера
			// для конкретного випадку
			observer: true,
			observeParents: true,
			slidesPerView: 1,
			spaceBetween: 16,
			autoHeight: true,
			// centeredSlides: true,
			// centerInsufficientSlides: true,
			speed: 800,

			//touchRatio: 0,
			//simulateTouch: false,
			//loop: true,
			//preloadImages: false,
			//lazy: true,

			/*
			 // Ефекти
			 effect: 'fade',
			 autoplay: {
				 delay: 3000,
				 disableOnInteraction: false,
			 },
			 */

			// Пагінація
			
			 pagination: {
				 el: '.slider-dots',
				 clickable: true,
			 },
			

			// Скроллбар
			/*
			 scrollbar: {
				 el: '.swiper-scrollbar',
				 draggable: true,
			 },
			 */

			// Кнопки "вліво/вправо"
			navigation: {
				prevEl: ".image-with-text__slider .slider-arrow.prev",
				nextEl: ".image-with-text__slider .slider-arrow.next",
			},

			// Брейкпоінти
			// breakpoints: {
			// 	320: {
			// 		slidesPerView: 1.15,
			// 		spaceBetween: 10,
			// 	},
			// 	467: {
			// 		slidesPerView: 1.8,
			// 		spaceBetween: 16,
			// 	},
			// 	640: {
			// 		slidesPerView: 3,
			// 		spaceBetween: 16,
			// 	},
			// },

			// Події
			on: {},
		});
	}
  
}

window.addEventListener("load", function (e) {
    document.body.classList.add('loaded');
	var windowWidth = window.innerWidth;
	if (windowWidth <= mediaQuerySize) sliderTagInit();
	if (windowWidth <= mediaQuerySize) sliderProductInit();
	if (windowWidth <= mediaQuerySize) sliderIconsInit();
	// if (windowWidth >= mediaQuerySize) sliderBlogPostsInit();
	// sliderBlogPostsInit();
	if (windowWidth <= mediaQuerySizeLarge) sliderOffersInit();
	initSliders();
});
window.addEventListener("resize", function (e) {
	var windowWidth = window.innerWidth;
	if (windowWidth <= mediaQuerySize) sliderTagInit();
	else sliderTagDestroy();
	if (windowWidth <= mediaQuerySize) sliderProductInit();
	else sliderProductDestroy();
	if (windowWidth <= mediaQuerySize) sliderIconsInit();
	else sliderIconsDestroy();
	// if (windowWidth >= mediaQuerySize) sliderBlogPostsInit();
	// else sliderBlogPostsDestroy();
	if (windowWidth <= mediaQuerySizeLarge) sliderOffersInit();
	else sliderOffersDestroy();
});document.addEventListener("DOMContentLoaded", function () {
  const productBulk = document.querySelector(".product-bulkdiscount");
  if(productBulk){
    const quantityInput = document.querySelector(".quantity-selector.quantity-selector--product input")
    const priceWrapper = document.querySelector(".product-form .priceWrapper");
    const regularPrice = priceWrapper.dataset.rawPrice;
    const comparePrice = priceWrapper.dataset.rawComparePrice;
    
    
    productBulk.addEventListener("click", function (e) {
	if(e.target.closest(".product-bulkdiscount--cell")){
      const currentBulk = e.target.closest(".product-bulkdiscount--cell");
      const productBulkInputValue = currentBulk.querySelector('input').value
      quantityInput.value = productBulkInputValue;
      let currentBulkPrice = document.querySelector('body').classList.contains("v2") ? parseInt(currentBulk.querySelector('.product-bulkdiscount--item-value').innerText.replace(",", "")) * productBulkInputValue : parseInt(currentBulk.querySelectorAll('.product-bulkdiscount--item-value span')[0].innerText.replace(",", ""));
      if(!currentBulkPrice){
          currentBulkPrice = regularPrice; 
      }
      if(document.querySelector('body').classList.contains("template-v3")){
        
      
      if(comparePrice && comparePrice!=regularPrice){
        const comparePriceWrapper = priceWrapper.querySelector(".price.price--compare");
        const regularPriceWrapper = priceWrapper.querySelector(".price.price--highlight");
        comparePriceWrapper.innerHTML = currentBulkPrice===regularPrice ? `<span class="visually-hidden">Regular price</span>${(comparePrice / 100 * productBulkInputValue).toFixed(2).toString().replace(".",",")}` : `<span class="visually-hidden">Regular price</span>${(regularPrice / 100 * productBulkInputValue).toFixed(2).toString().replace(".",",")}`;
        regularPriceWrapper.innerHTML = `<span class="visually-hidden">Sale price</span>${(currentBulkPrice / 100 ).toFixed(2).toString().replace(".",",")}`
       
        if((regularPrice / 100 * productBulkInputValue) === (currentBulkPrice / 100)){
                  comparePriceWrapper.innerHTML = `<span class="visually-hidden">Regular price</span>${(comparePrice / 100 * productBulkInputValue).toFixed(2).toString().replace(".",",")}`;
        }
      } else{
        const regularPriceWrapper = priceWrapper.querySelector(".price");
        regularPriceWrapper.innerHTML = `<span class="visually-hidden">Sale price</span>${(currentBulkPrice / 100 ).toFixed(2).toString().replace(".",",")}`
      }
      }
    }
});
  }

  const judgemeButton = document.querySelector('#judgeme_product_reviews .jdgm-write-rev-link')
  if(judgemeButton){
	
    judgemeButton.addEventListener("click", function (e) {

      document.querySelector('.popup-open-link').click();
       const judgemeForm = document.querySelector('#judgeme_product_reviews .jdgm-form');
         const judgemeFormName = judgemeForm.querySelector('input[name="reviewer_name"]');
      const judgemeFormEmail = judgemeForm.querySelector('input[name="reviewer_email"]');
      const judgemeFormScore = judgemeForm.querySelector('input[name="score"]');
      const judgemeFormTitle = judgemeForm.querySelector('input[name="review_title"]');
      const judgemeFormBody = judgemeForm.querySelector('textarea[name="review_body"]');
      const judgemeFormPhoto = judgemeForm.querySelector('input[name="pictures"]');
      const judgemeFormVideo = judgemeForm.querySelector('input[name="video"]');
      const judgemeFormSubmit = judgemeForm.querySelector('input[type="submit"]');

      const popupForm = document.querySelector('#review-form .review-form__body');
      const productID = popupForm.dataset.product;
      const popupFormName = popupForm.querySelector('input[name="reviewer_name"]');
      const popupFormEmail = popupForm.querySelector('input[name="reviewer_email"]');
      const popupFormScore = popupForm.querySelector('.rating');
      const popupFormTitle = popupForm.querySelector('textarea[name="review_title"]');
      const popupFormBody = popupForm.querySelector('input[name="review_body"]');
      const popupFormPhoto = popupForm.querySelector('input[name="pictures"]');
      const popupFormVideo = popupForm.querySelector('input[name="video"]');
      const popupFormSubmit = popupForm.querySelector('.review-form__submit');

      if (popupFormPhoto) {
         const photoItems = popupForm.querySelector(".review-form__pictures");
      
        let files;
      
       popupFormPhoto.addEventListener("change", function () {
          //getting user select file and [0] this means if user select multiple files then we'll select only the first one
          files = this.files;
        
          showFile(); //calling function
        });
      
        function showFile() {
          let file;
          const dataTransfer = new DataTransfer();
          for (let i = 0; i < files.length; i++) {
            file = files[i];
            let fileType = file.type; //getting selected file type
            let validExtensions = ["image/jpeg", "image/jpg", "image/png","image/webp", "image/gif"]; //adding some valid image extensions in array
            if (validExtensions.includes(fileType)) {
              let fileName = file.name;
              //if user selected file is an image file
              let fileReader = new FileReader(); //creating new FileReader object
              fileReader.onload = () => {
                let fileURL = fileReader.result; //passing user file source in fileURL variable
                let imgItem = ` <div data-name='${fileName}' class="addphoto__item">
          	 							 <div class="addphoto__image-ibg">
          		 							<img src="${fileURL}" alt="review" />
          	 							 </div>
          	 							 <div class="addphoto__body">
          									 <div class="addphoto__close">
                    <svg
            focusable="false"
            viewBox="0 0 19 19"
            role="presentation">
            <path
              d="M9.1923882 8.39339828l7.7781745-7.7781746 1.4142136 1.41421357-7.7781746 7.77817459 7.7781746 7.77817456L16.9705627 19l-7.7781745-7.7781746L1.41421356 19 0 17.5857864l7.7781746-7.77817456L0 2.02943725 1.41421356.61522369 9.1923882 8.39339828z"
              fill="currentColor"
              fill-rule="evenodd"></path>
          </svg></div>
                                          </div>
          								</div>`;
                photoItems.insertAdjacentHTML("beforeend", imgItem);
              };
              fileReader.readAsDataURL(file);
             
              dataTransfer.items.add(file);
            } else {
              alert("This is not an Image File!");
            }
          }
          const fileList = dataTransfer.files;
          judgemeFormPhoto.files = fileList;
          
        }
        //Delete Item
        photoItems.addEventListener("click", deleteItem);
      
        function deleteItem(e) {
          if (e.target.closest(".addphoto__close")) {
            const close = e.target.closest(".addphoto__close");
            const currentPhoto = close.closest(".addphoto__item");
            currentPhoto.remove();
            const photoName = currentPhoto.dataset.name;
            const dt = new DataTransfer();
            const { files } = judgemeFormPhoto;
            for (let i = 0; i < files.length; i++) {
                const file = files[i];  
                if (file.name !== photoName) {
                  dt.items.add(file); // here you exclude the file. thus removing it.
                }
              }
        
        /* Assigning data transfer object files to the 'input' variable will not write the data transfer files to it because it doesn't have the reference to the element: Instead write, */
        judgemeFormPhoto.files = dt.files; // Assign the updates list
        popupFormPhoto.files = dt.files
          }
        }
      }
      if (popupFormVideo) {
         const videoItems = popupForm.querySelector(".review-form__video");
      
        let files;
      
        popupFormVideo.addEventListener("change", function () {
          //getting user select file and [0] this means if user select multiple files then we'll select only the first one
          files = this.files;
          //  dropArea.classList.add("active");
          showFile(); //calling function
        });
      
        function showFile() {
          let file;
          const dataTransfer = new DataTransfer();
          for (let i = 0; i < files.length; i++) {
            file = files[i];
      
            let fileType = file.type; //getting selected file type
            // let validExtensions = ["video/mov","video/mp4","video/x-m4v","video/*"]; //adding some valid image extensions in array
            // if (validExtensions.includes(fileType)) {
            if (true) {
              //if user selected file is an image file
              let fileReader = new FileReader(); //creating new FileReader object
               let fileName = file.name;
              fileReader.onload = () => {
                let fileURL = fileReader.result; //passing user file source in fileURL variable
                
                let imgItem = ` <div data-name="${fileName}" class="addphoto__item">
                <?xml version="1.0" encoding="iso-8859-1"?>
                    <svg class="addphoto__item-video-bg" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                    	 viewBox="0 0 32 32" style="enable-background:new 0 0 32 32;" xml:space="preserve">
                    <g>
                    	<path style="fill:#010002;" d="M24,14.059V5.584L18.414,0H0v32h24v-0.059c4.499-0.5,7.998-4.31,8-8.941
                    		C31.998,18.366,28.499,14.557,24,14.059z M17.998,2.413L21.586,6h-3.588C17.998,6,17.998,2.413,17.998,2.413z M2,30V1.998h14v6.001
                    		h6v6.06c-0.693,0.076-1.361,0.238-2,0.464V12H8v3l-4-3v10l4-3v3h6.059C14.022,22.329,14,22.661,14,23c0,2.829,1.308,5.352,3.35,7H2
                    		z M23,29.883c-3.801-0.009-6.876-3.084-6.885-6.883c0.009-3.801,3.084-6.876,6.885-6.885c3.799,0.009,6.874,3.084,6.883,6.885
                    		C29.874,26.799,26.799,29.874,23,29.883z"/>
                    	<path style="fill:#010002;" d="M19,27h3l-3-3V27z M19.999,23l5-5L28,21l-5,5L19.999,23z"/>
                    </g>
                    </svg>
      
          	 							 <div class="addphoto__image-ibg">
          		 							
                    <video src="${fileURL}"></video>
          	 							 </div>
          	 							 <div class="addphoto__body">
          									 <div class="addphoto__close">
                    <svg
            focusable="false"
            viewBox="0 0 19 19"
            role="presentation">
            <path
              d="M9.1923882 8.39339828l7.7781745-7.7781746 1.4142136 1.41421357-7.7781746 7.77817459 7.7781746 7.77817456L16.9705627 19l-7.7781745-7.7781746L1.41421356 19 0 17.5857864l7.7781746-7.77817456L0 2.02943725 1.41421356.61522369 9.1923882 8.39339828z"
              fill="currentColor"
              fill-rule="evenodd"></path>
          </svg></div>
                                          </div>
          								</div>`;
                videoItems.insertAdjacentHTML("beforeend", imgItem);
                const videoInputLabel = videoItems.querySelector('.review-form__row--media-video') 
                videoInputLabel.style.display="none";
              };
              fileReader.readAsDataURL(file);
               dataTransfer.items.add(file);
            } else {
              alert("This is not an Video File!");
            }
          }
          const fileList = dataTransfer.files;
          judgemeFormVideo.files = fileList;
        }
        //Delete Item
        videoItems.addEventListener("click", deleteItemVideo);
      
        function deleteItemVideo(e) {
          if (e.target.closest(".addphoto__close")) {
            const close = e.target.closest(".addphoto__close");
            const currentPhoto = close.closest(".addphoto__item");
            currentPhoto.remove();
            const videoInputLabel = videoItems.querySelector('.review-form__row--media-video') 
            videoInputLabel.style.display="inline-block";
            const photoName = currentPhoto.dataset.name;
            const dt = new DataTransfer();
            const { files } = judgemeFormVideo;
            for (let i = 0; i < files.length; i++) {
                const file = files[i];  
                if (file.name !== photoName) {
                  dt.items.add(file); // here you exclude the file. thus removing it.
                }
              }
        /* Assigning data transfer object files to the 'input' variable will not write the data transfer files to it because it doesn't have the reference to the element: Instead write, */
        judgemeFormVideo.files = dt.files; // Assign the updates list
        popupFormVideo.files = dt.files
          }
        }
      }
      
// //Add video
// const videoButton = document.querySelector(".addvideo__button");
// if (videoButton) {
//   const videoRow = videoButton.closest(".phototype-advertisement__addvideo");
//   const videoInput = videoRow.querySelector(".addvideo__input");

//   videoButton.addEventListener("click", function (e) {
//     if (
//       videoInput.value !== " " &&
//       videoRow.classList.contains("_video-active")
//     ) {
//       let videoLink = videoInput.value;
//       if (validateYouTubeUrl(videoLink)) {
//         const linkId = getYoutubeUrlId(videoLink);
//         let videoBlock = `  <div class="addvideo__video-block">
//         <div class="addvideo__close _icon-close"></div>
//         <iframe
// 		   src="https://www.youtube.com/embed/${linkId}"
//       	 title="YouTube video player"
//       	 frameborder="0"
//       	 allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
//       	 allowfullscreen
//         ></iframe>
//       </div>`;
//         videoRow.insertAdjacentHTML("beforeend", videoBlock);
//       }

//       videoRow.insertAdjacentHTML("beforeend", videoBlock);
//     }

//     function getYoutubeUrlId(url) {
//       const urlObject = new URL(url);
//       let urlOrigin = urlObject.origin;
//       let urlPath = urlObject.pathname;

//       if (urlOrigin.search("youtu.be") > -1) {
//         return urlPath.substr(1);
//       }
//       if (urlPath.search("embed") > -1) {
//         return urlPath.substr(7);
//       }
//       return urlObject.searchParams.get("v");
//     }

//     videoRow.classList.add("_video-active");
//     videoButton.innerHTML = "Завантажити";
//   });
//   function validateYouTubeUrl(urlToParse) {
//     if (urlToParse) {
//       var regExp =
//         /^(?:https?:\/\/)?(?:m\.|www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/;
//       if (urlToParse.match(regExp)) {
//         return true;
//       }
//     }
//     return false;
//   }

//   videoRow.addEventListener("click", function (e) {
//     if (e.target.closest(".addvideo__close")) {
//       const videoBlock = videoRow.querySelector(".addvideo__video-block");
//       videoBlock.remove();
//     }
//   });
// }

  formFieldsInit({
	viewPass: false,
	autoHeight: false
});
      
      popupFormSubmit.addEventListener("click", function (e) {
	
      const error = formValidate.getErrors(popupForm);
     if (error === 0 && popupFormScore.getAttribute("title")) {
			judgemeFormName.value = popupFormName.value;
			judgemeFormEmail.value = popupFormEmail.value;
			judgemeFormScore.value = popupFormScore.getAttribute("title");
			judgemeFormTitle.value = popupFormTitle.value;
			judgemeFormBody.value = popupFormBody.value;
				setTimeout(() => {
				judgemeFormSubmit.click();
				 judgemeFormSubmit.classList.add("review-sent")
			}, 50);
			setTimeout(() => {
				judgemeFormSubmit.click();
				 judgemeFormSubmit.classList.add("review-sent")
			}, 50);
			console.log(judgemeFormName.value,judgemeFormEmail.value, judgemeFormScore.value, judgemeFormTitle.value, judgemeFormBody.value)
		}
      })    
    })
    
  }

 
})


function formFieldsInit(options = { viewPass: false, autoHeight: false }) {
	document.body.addEventListener("focusin", function (e) {
		const targetElement = e.target;
		if ((targetElement.tagName === 'INPUT' || targetElement.tagName === 'TEXTAREA')) {
			if (!targetElement.hasAttribute('data-no-focus-classes')) {
				targetElement.classList.add('_form-focus');
				targetElement.parentElement.classList.add('_form-focus');
			}
			formValidate.removeError(targetElement);
			targetElement.hasAttribute('data-validate') ? formValidate.removeError(targetElement) : null;
		}
	});
	document.body.addEventListener("focusout", function (e) {
		const targetElement = e.target;
		if ((targetElement.tagName === 'INPUT' || targetElement.tagName === 'TEXTAREA')) {
			if (!targetElement.hasAttribute('data-no-focus-classes')) {
				targetElement.classList.remove('_form-focus');
				targetElement.parentElement.classList.remove('_form-focus');
			}
			// Миттєва валідація
			// English translation: Instant Validation
			targetElement.hasAttribute('data-validate') ? formValidate.validateInput(targetElement) : null;
		}
	});
	// Якщо увімкнено, додаємо функціонал "Показати пароль"
	// English translation: 
	if (options.viewPass) {
		document.addEventListener("click", function (e) {
			let targetElement = e.target;
			if (targetElement.closest('[class*="__viewpass"]')) {
				let inputType = targetElement.classList.contains('_viewpass-active') ? "password" : "text";
				targetElement.parentElement.querySelector('input').setAttribute("type", inputType);
				targetElement.classList.toggle('_viewpass-active');
			}
		});
	}
	// Якщо увімкнено, додаємо функціонал "Автовисота"
	// English translation: If enabled, add "Auto Height" functionality
	
	if (options.autoHeight) {
		const textareas = document.querySelectorAll('textarea[data-autoheight]');
		if (textareas.length) {
			textareas.forEach(textarea => {
				const startHeight = textarea.hasAttribute('data-autoheight-min') ?
					Number(textarea.dataset.autoheightMin) : Number(textarea.offsetHeight);
				const maxHeight = textarea.hasAttribute('data-autoheight-max') ?
					Number(textarea.dataset.autoheightMax) : Infinity;
				setHeight(textarea, Math.min(startHeight, maxHeight))
				textarea.addEventListener('input', () => {
					if (textarea.scrollHeight > startHeight) {
						textarea.style.height = `auto`;
						setHeight(textarea, Math.min(Math.max(textarea.scrollHeight, startHeight), maxHeight));
					}
				});
			});
			function setHeight(textarea, height) {
				textarea.style.height = `${height}px`;
			}
		}
	}
}
// Валідація форм
// English translation: Form Validation
let formValidate = {
	getErrors(form) {
		let error = 0;
		let formRequiredItems = form.querySelectorAll('*[data-required]');
		if (formRequiredItems.length) {
			formRequiredItems.forEach(formRequiredItem => {
				if (!formRequiredItem.disabled) {
					error += this.validateInput(formRequiredItem);
				}
			});
		}
		return error;
	},
	validateInput(formRequiredItem) {
		let error = 0;
		if (formRequiredItem.dataset.required === "email") {
			formRequiredItem.value = formRequiredItem.value.replace(" ", "");
			if (this.emailTest(formRequiredItem)) {
				this.addError(formRequiredItem);
				error++;
			} else {
				this.removeError(formRequiredItem);
			}
		} else if (formRequiredItem.type === "checkbox" && !formRequiredItem.checked) {
			this.addError(formRequiredItem);
			error++;
		} else {
			if (!formRequiredItem.value.trim()) {
				this.addError(formRequiredItem);
				error++;
			} else {
				this.removeError(formRequiredItem);
			}
		}
		return error;
	},
	addError(formRequiredItem) {
		formRequiredItem.classList.add('_form-error');
		formRequiredItem.parentElement.classList.add('_form-error');
		let inputError = formRequiredItem.parentElement.querySelector('.form__error');
		if (inputError) formRequiredItem.parentElement.removeChild(inputError);
		if (formRequiredItem.dataset.error) {
			formRequiredItem.parentElement.insertAdjacentHTML('beforeend', `<div class="form__error">${formRequiredItem.dataset.error}</div>`);
		}
      let tabBody = formRequiredItem.closest(".tabs__body");
      if(tabBody){
         let tabBodyIndex = tabBody.dataset.index;
        let currentForm = formRequiredItem.closest("form");
        let tabNavigation = currentForm.querySelector(`.tabs__title[data-index="${tabBodyIndex}"]`);
        if(!tabNavigation.classList.contains("title-error") && !tabNavigation.classList.contains("_tab-active")){
          tabNavigation.classList.add("title-error")
        }
        setTimeout(() => {
        	tabNavigation.classList.contains("title-error") ? tabNavigation.classList.remove("title-error") : null;
        }, 3000);
        }
      
      
	},
	removeError(formRequiredItem) {
		formRequiredItem.classList.remove('_form-error');
		formRequiredItem.parentElement.classList.remove('_form-error');
		if (formRequiredItem.parentElement.querySelector('.form__error')) {
			formRequiredItem.parentElement.removeChild(formRequiredItem.parentElement.querySelector('.form__error'));
		}
      //  let tabBody = formRequiredItem.closest(".tabs__body");
      // if(tabBody){
      //    let tabBodyIndex = tabBody.dataset.index;
      //   let currentForm = formRequiredItem.closest("form");
      //   let tabNavigation = currentForm.querySelector(`.tabs__title[data-index="${tabBodyIndex}"]`);
      //   tabNavigation.classList.contains("title-error") ? tabNavigation.classList.remove("title-error") : null;
      // }
	},
	formClean(form) {
		form.reset();
		setTimeout(() => {
			let inputs = form.querySelectorAll('input,textarea');
			for (let index = 0; index < inputs.length; index++) {
				const el = inputs[index];
				el.parentElement.classList.remove('_form-focus');
				el.classList.remove('_form-focus');
				formValidate.removeError(el);
			}
			let checkboxes = form.querySelectorAll('.checkbox__input');
			if (checkboxes.length > 0) {
				for (let index = 0; index < checkboxes.length; index++) {
					const checkbox = checkboxes[index];
					checkbox.checked = false;
				}
			}
			
		}, 0);
	},
	emailTest(formRequiredItem) {
		return !/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,8})+$/.test(formRequiredItem.value);
	}
}
document.addEventListener("afterPopupClose", function (e) {

    //  if(e.detail.popup.targetOpen.selector=="#review-form"){

    if(e.detail.popup.hash=="#review-form"){

        const currentPopup = document.querySelector("#review-form");

        const errors = currentPopup.querySelectorAll("._form-error");

        const submitButton = currentPopup.querySelector(".review-form__submit");

        if(errors && errors.length>0 || !submitButton.classList.contains("review-sent")){

                const confirmOpen = document.querySelector(".popup-confirm-link")

                setTimeout(() => {

                    confirmOpen ? confirmOpen.click() : null;

                }, 500);

            const confirmPopup = document.querySelector("#review-form-confirm");

            confirmPopup.addEventListener("click", function(e){

                if(e.target.closest(".confirm-button__agree")){

                    confirmPopup.querySelector(".popup__close").click();

                }

                if(e.target.closest(".confirm-button__decline")){

                    setTimeout(() => {

                     const reviewPopupLink = document.querySelector(".popup-open-link");

                    reviewPopupLink.click();

                    submitButton.classList.add("review-sent")

                }, 500);

                   

                }

            })

    }

    }

	

});